import React, { useEffect } from "react";
import MainRoutes from "routes/Routes";
import "./styles/index.scss";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		console.error("Error caught by boundary:", error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div style={{ padding: '20px', textAlign: 'center' }}>
					<h1>Something went wrong</h1>
					<p>{this.state.error?.message}</p>
					<button onClick={() => window.location.reload()}>Reload</button>
				</div>
			);
		}
		return this.props.children;
	}
}

function App() {
	useEffect(() => {
		console.log("App mounted");
		// Remove preloader
		const preloader = document.querySelector('.preloader');
		if (preloader) {
			preloader.classList.add('hidden');
		}
	}, []);

	return (
		<ErrorBoundary>
			<div style={{ minHeight: '100vh' }}>
				<MainRoutes />
			</div>
		</ErrorBoundary>
	);
}

export default App;
